import axios from 'axios';

// 1. Obtenemos la URL base (sin barra final para estandarizar)
const envUrl = process.env.REACT_APP_API_URL 
  ? process.env.REACT_APP_API_URL.replace(/\/$/, '') 
  : 'http://localhost:5000';

// 2. Definimos la baseURL asegurando el prefijo /api
const clienteAxios = axios.create({
  baseURL: `${envUrl}/api/`
});

export default clienteAxios;